import React from 'react';
import PropTypes from 'prop-types';
import ProductVariationsProp from '../../propTypes/productVariationsProp';

function CartItemImage(props) {
  const { product } = props;
  return (
    <div className="product-image">
      <img src={product?.images[0]?.url || ''} alt={product.name} />
    </div>
  );
}

CartItemImage.propTypes = {
  product: PropTypes.shape(ProductVariationsProp.propType).isRequired,
};

export default CartItemImage;
